import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { toDateTime } from '../../../utils/date-time';

@Pipe({ name: 'appIsoDate' })
export class AppIsoDatePipe implements PipeTransform {
    transform(value: any, format?: string): any {
        const instance = toDateTime(value);

        if (instance?.isValid) {
            return instance.toISODate();
        }

        return value;
    }
}
